<nz-layout>
  <nz-header>
    <span class="section-header">{{'Hysteroscopy'|translate}}</span>
  </nz-header>
  <nz-content>
    <!-- <app-hysteroscopy-examination></app-hysteroscopy-examination> -->
    <app-hysteroscopy-start-examination></app-hysteroscopy-start-examination>
    <app-hysteroscopy-file></app-hysteroscopy-file>
  </nz-content>
</nz-layout>